import { Button, Modal } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

import { FilterEditorError } from "./utils/filterEditorSchema";

interface FilterErrorsModalProps {
    errors: FilterEditorError[];
    open: boolean;
    onClose: () => void;
}

export const FilterErrorsModal = ({ errors, open, onClose }: FilterErrorsModalProps) => {
    const { t } = usePaldockTranslation("ui.offer-filter");

    return (
        <Modal
            open={open}
            title={t("validation.modal_title")}
            onCancel={onClose}
            footer={[
                <Button key="close" onClick={onClose}>
                    {t("validation.close")}
                </Button>,
            ]}
        >
            <ul className="list-disc pl-4 space-y-2">
                {errors.map((error) => (
                    <li key={`${error.nodeId}-${error.field}-${error.messageKey}`}>
                        {t("validation.location", { location: error.location.join(".") })}:{" "}
                        {t(error.messageKey, error.params)}
                    </li>
                ))}
            </ul>
        </Modal>
    );
};
